import { render, staticRenderFns } from "./reviewOrder.vue?vue&type=template&id=48976dc9&scoped=true"
import script from "./reviewOrder.vue?vue&type=script&lang=js"
export * from "./reviewOrder.vue?vue&type=script&lang=js"
import style0 from "./reviewOrder.vue?vue&type=style&index=0&id=48976dc9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48976dc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48976dc9')) {
      api.createRecord('48976dc9', component.options)
    } else {
      api.reload('48976dc9', component.options)
    }
    module.hot.accept("./reviewOrder.vue?vue&type=template&id=48976dc9&scoped=true", function () {
      api.rerender('48976dc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reviewOrder/reviewOrder.vue"
export default component.exports